import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {GrowthPlanService} from "../../../tpiq-services/growth-plan.service";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {Session} from "../../../services/Session";
import {v4 as uuid} from 'uuid';
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-one-on-one',
  standalone: true,
  imports: [CommonModule, FormsModule, FileUploadModule, FroalaEditorModule, FroalaViewModule],
  templateUrl: './one-on-one.component.html',
  styleUrl: './one-on-one.component.scss'
})
export class OneOnOneComponent implements OnInit, OnDestroy {
  @Input() event: any;
  @Output() onUpdateOfEvent: EventEmitter<any> = new EventEmitter<any>();
  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  logoFiles = [];

  editorOptions = {
    heightMin: 100,
    heightMax: 300,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  eventLinks: Array<any> = [];
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private growthPlanService: GrowthPlanService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.eventLinks = this.event.link || [];
    this.uploaderUpdate();
    this.buildItemForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  uploaderUpdate() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getFirmLogoUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    const base = this;
    const user: any = Session.getUser();
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceType = "firm_logo";
      payload.sourceId = uuid();
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploader.progress = 100;
        const document: any = JSON.parse(response);
        this.event.thumbnailUrl = document.temporaryURL;
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.temporaryURL;
          this.logoFiles = [];
          this.logoFiles.push(obj);
        }
        this.loadingService.triggerLoadingEvent(false);
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Upload Logo');
        this.loadingService.triggerLoadingEvent(false);
      }
    };
  }

  fileDropOver($event){
    this.loadingService.triggerLoadingEvent(true);
    this.uploader.uploadAll();
  }

  fileOverBase($event){
    this.hasBaseDropZoneOver = $event;
  }

  deleteDocumentFile(file, index){
    this.logoFiles.splice(index, 1);
    if (this.logoFiles.length === 0) {
      this.event.thumbnailUrl = '';
    }
  }

  resetUploader() {
    this.uploader.queue.forEach(function(item) {
      item.remove();
    });
  }

  updateOneOnOne() {
    this.event.link = JSON.stringify(this.eventLinks);
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.updateOneOnOneEvent(this.org, this.user.id, this.event)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'updated successfully');
        this.onUpdateOfEvent.emit({data: this.event});
        this.resetUploader();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To update`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  removeEventLink(index){
    this.eventLinks.splice(index, 1);
  }

  addLLink() {
    this.eventLinks.push({});
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);

  }

  scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

}
